exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-nav-desktop[data-v-5c5ff2d0] {\n  padding-bottom: 1px;\n}\n.site-nav-desktop .site-nav-item[data-v-5c5ff2d0] {\n  display: inline-block;\n  vertical-align: text-bottom;\n  color: #343434;\n  border: 1px solid transparent;\n}\n.site-nav-desktop .site-nav-item button[data-v-5c5ff2d0] {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n}\n.site-nav-desktop .site-nav-item .site-nav-title-content[data-v-5c5ff2d0] {\n  display: block;\n  padding: 0.5em 1.2em;\n}\n", ""]);

// exports
